import { IconPropsType } from "./type";

export const Stars = ({ size = 24, color = "currentColor" }: IconPropsType) => (
  <svg width={size} height={size} viewBox="0 0 15 14" fill="none">
    <path
      d="M7.12655 1.64151C7.15154 1.5077 7.22255 1.38684 7.32727 1.29987C7.43199 1.21289 7.56384 1.16528 7.69996 1.16528C7.83609 1.16528 7.96794 1.21289 8.07266 1.29987C8.17738 1.38684 8.24839 1.5077 8.27338 1.64151L8.88646 4.88368C8.93001 5.11418 9.04203 5.32621 9.2079 5.49208C9.37377 5.65795 9.58579 5.76997 9.8163 5.81351L13.0585 6.4266C13.1923 6.45159 13.3131 6.5226 13.4001 6.62732C13.4871 6.73204 13.5347 6.86388 13.5347 7.00001C13.5347 7.13614 13.4871 7.26798 13.4001 7.37271C13.3131 7.47743 13.1923 7.54844 13.0585 7.57343L9.8163 8.18651C9.58579 8.23006 9.37377 8.34207 9.2079 8.50795C9.04203 8.67382 8.93001 8.88584 8.88646 9.11635L8.27338 12.3585C8.24839 12.4923 8.17738 12.6132 8.07266 12.7002C7.96794 12.7871 7.83609 12.8347 7.69996 12.8347C7.56384 12.8347 7.43199 12.7871 7.32727 12.7002C7.22255 12.6132 7.15154 12.4923 7.12655 12.3585L6.51346 9.11635C6.46992 8.88584 6.3579 8.67382 6.19203 8.50795C6.02616 8.34207 5.81413 8.23006 5.58363 8.18651L2.34146 7.57343C2.20765 7.54844 2.08679 7.47743 1.99982 7.37271C1.91284 7.26798 1.86523 7.13614 1.86523 7.00001C1.86523 6.86388 1.91284 6.73204 1.99982 6.62732C2.08679 6.5226 2.20765 6.45159 2.34146 6.4266L5.58363 5.81351C5.81413 5.76997 6.02616 5.65795 6.19203 5.49208C6.3579 5.32621 6.46992 5.11418 6.51346 4.88368L7.12655 1.64151Z"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3667 1.16669V3.50002"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5335 2.33331H11.2002"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.03337 12.8333C3.6777 12.8333 4.20003 12.311 4.20003 11.6667C4.20003 11.0223 3.6777 10.5 3.03337 10.5C2.38903 10.5 1.8667 11.0223 1.8667 11.6667C1.8667 12.311 2.38903 12.8333 3.03337 12.8333Z"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
